module.exports = __webpack_public_path__ + "media/defender-guild.d275f2d1.mp3";